export interface ISlots {
  slot_price: number;
  slots_invoice: number;
  slot_assigned: number;
  slot_max: number;
  slot_min: number;
  date_payment: string;
  date_payment_finish: string;
  price_now: number;
  slot_type_billing: number | string;
  slot_price_now: number;
  call: unknown[];
  whatsapp: unknown[];
  slot_deleted: number;
  slot_paid?: boolean;
  summary_balance: number;
  summary_type_billing: string;
  summary_enable_by?: unknown[];
  summary_enable_at: unknown;
  tax: number;
}

export interface IItems {
  title: string;
  subtitle?: string;
  tooltip?: boolean;
  redirect?: string;
}

export interface IFilters {
  search?: string;
  status?: string;
  slots?: string;
  currentYear?: number | null;
  currentMonth?: number | null;
}

export enum UserStatus {
  Activo = 1,
  Inactivo = 2,
  Pendiente = 4,
}
